import { GenericAiWidgetData } from '../../../types'
import { WidgetNode } from '../../'

export class GenericAiWidgetNode extends WidgetNode<GenericAiWidgetData> {
  public getValue(): string | undefined {
    return this.data.value
  }

  public isEmpty(): boolean {
    return !this.getValue()
  }
}
